import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  Cell,
} from 'recharts';
import ChartTitle from '../../../../../elements/ChartTitle';
import NoDataAvailable from '../NoDataAvailable';
import { Spinner } from 'react-bootstrap';
import { coloursArray } from '../../../../../../lib/utils';

const VelocityInstabilityChart = ({ data, loading, isJiraIntegrated }) => {
  const [chartData, setChartData] = useState([]);
  const [meanVelocity, setMeanVelocity] = useState(0);
  const [stdDeviation, setStdDeviation] = useState(0);
  const [instability, setInstability] = useState(0);

  useEffect(() => {
    if (!data?.length) {
      setChartData([]);
      setMeanVelocity(0);
      setStdDeviation(0);
      setInstability(0);
      return;
    }

    const processed = data.map((sprint, index) => {
      const completed = sprint.completedStoryPoints || 0;
      return {
        sprint: sprint.sprintName || `Sprint ${index + 1}`,
        completed,
        fill: coloursArray[index % coloursArray.length],
      };
    });

    const completedValues = processed.map((s) => s.completed);

    const mean =
      completedValues.reduce((sum, val) => sum + val, 0) /
      completedValues.length;

    const variance =
      completedValues.reduce((sum, val) => sum + (val - mean) ** 2, 0) /
      completedValues.length;

    const stdDev = Math.sqrt(variance);
    const instabilityValue = mean ? stdDev / mean : 0;

    setChartData(processed);
    setMeanVelocity(+mean.toFixed(2));
    setStdDeviation(+stdDev.toFixed(2));
    setInstability(+instabilityValue.toFixed(2));
  }, [data]);

  const subtitle = `Standard Deviation: ${stdDeviation}, Instability: ${instability}`;
  return (
    <div className="chart-div">
      <ChartTitle title="Velocity Instability" subtitle={subtitle} showWarning={!isJiraIntegrated} />
      {loading ? (
        <Spinner className="mt-5" />
      ) : chartData.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            barSize={30}
            margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="sprint" tick={{ fontSize: 12 }} />
            <YAxis />
            <Tooltip />
            <Bar
              dataKey="completed"
              name="Completed SP"
              isAnimationActive={false}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Bar>
            {meanVelocity > 0 && (
              <ReferenceLine
                y={meanVelocity}
                stroke="#000000"
                strokeDasharray="3 3"
                label={{
                  value: `Mean (${Math.round(meanVelocity)})`,
                  position: 'top',
                  fontSize: 12,
                  fill: '#000000',
                }}
              />
            )}
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default VelocityInstabilityChart;
